import React from "react";

function Hqaddress() {
  return (

    <div className="hqslide_box">
                <p>PCF Sparkletots Preschool Blk 409, Bedok North Ave 2 #01-26 Singapore 460409</p>
              </div>

    );
}

export default Hqaddress;
